<template>
<!-- v-loading="loading" element-loading-text="拼命加载中" -->
  <div class="index ele-box"  v-loading="loading" element-loading-text="拼命加载中">
    <div class="fixedTop">
     <!-- <el-tabs v-if="info.provincialAndMunicipalLevel==3" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane  label="乡镇街道" name="乡镇街道">
        </el-tab-pane>
        <el-tab-pane label="村级防疫员" name="村级防疫员">
        </el-tab-pane>
      </el-tabs> -->
      <!-- v-else -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane  label="人员设置" name="人员设置">
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="title">
      <h3>人员设置</h3>
    </div> -->
    <div class="topCont">
      <div class="pdaBoxs">
        <el-form ref="form" :model="form">
          <el-form-item style="width: 160px;">
           <!-- <el-select @change="changeCitys" v-model="form.queryCityAreas" placeholder="选择辖区">
              <el-option label="全部辖区" value=""></el-option>
              <el-option
                   v-for="(item,index) in cityList"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id"
                   >{{item.name}}
                 </el-option>
            </el-select> -->
            <!-- authProvincesCityAreasName -->
            <el-input  v-model="info.authProvincesCityAreasName" disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item style="width: 160px;">
            <el-select @change="changeOrigin"  v-model="form.deptId"  placeholder="选择机构">
              <el-option label="全部机构" value=""></el-option>
              <el-option
                   v-for="(item,index) in originList"
                   :key="item.deptId"
                   :label="item.name"
                   :value="item.deptId"
                   >{{item.name}}
                 </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:160px">
            <el-input @input="changeName" v-model="form.realName" placeholder="请输入姓名查询"></el-input>
          </el-form-item>
          <el-form-item style="width:160px">
            <el-input @input="changePhone" v-model="form.phone" placeholder="请输入电话号码"></el-input>
          </el-form-item>
        <!-- <el-form-item style="width:160px">
            <el-select  @change="changeType" v-model="form.optAuthType" placeholder="请选择角色类型">
              <el-option label="请选择角色类型" value=""></el-option>
              <el-option label="操作员" value="0"></el-option>
              <el-option label="管理员" value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="items" v-if="handleIndex==1">
            <el-button type="success" plain @click="onSubmit">搜索</el-button>
            <el-button type="info" plain @click="reset" style="background-color: #fff;border:none">重置</el-button>
          </el-form-item>
         <!-- <div class="btnBox" v-if="info.optAuthType=='2'">
            <el-button type="primary" @click="addPerson" style="margin-left:20px">新增 +</el-button>
            <el-button type="primary">导入 ↘</el-button>
          </div> -->
          <div class="clear"></div>
          <div class="typeList over_h">
            <div class="typeItem" @click="tabClick(item,index)" v-for="(item,index) in typeList" :class="tabIndex == index ? 'cur':''">
              {{item.typeName}}<b>{{item.num}}</b>
            </div>
          </div>
        </el-form>
        <el-dialog :visible.sync="showAddDialog" width="960px" @click="closeDialog">
           <el-form label-width="120px">
              <div class="maskBox">
                <h1 style="font-size:20px;">{{addTitle}}</h1>
                <div class="absolutes">
                <div>
                  <!-- <div class="layui-form-item leftBlock" style="width: 100%;">
                    <div class="over_h">
                      物料名称
                      <span class="red">*</span>
                    </div>
                    <div class="layui-input-block mar_t15">
                      <input type="text" name="wulName" v-model="newData.name" lay-verify="wulName" autocomplete="off"  class="layui-input wulName">
                    </div>
                  </div> -->
                  <div class="layui-form-item leftBlock">
                    <div class="over_h">
                      姓名<span class="red">*</span>
                    </div>
                    <div class="layui-input-block mar_t15">
                      <input type="text" name="Manufacturer" v-model="newData.realName" lay-verify="Manufacturer" autocomplete="off"  class="layui-input Manufacturer">
                    </div>
                  </div>
                  <div class="layui-form-item leftBlock">
                    <div class="over_h">
                      手机号码<span class="red">*</span>
                    </div>
                    <div class="layui-input-block mar_t15">
                      <input type="text" name="Manufacturer" v-model="newData.phone" lay-verify="Manufacturer" autocomplete="off"  class="layui-input Manufacturer">
                    </div>
                  </div>
                  <div class="layui-form-item leftBlock">
                    <div class="over_h">
                      角色类型<span class="red">*</span>
                    </div>
                <div class="layui-input-block mar_t15 typess" >
                    <div v-for="(item,index) in typess" @click="types(item,index)" :class="active == index ? 'cur':''">{{item.name}}</div>
                  </div>
                   <!-- <div class="layui-input-block mar_t15">
                      <input type="text" name="Manufacturer" v-model="newData.factory" lay-verify="Manufacturer" autocomplete="off"  class="layui-input Manufacturer">
                    </div> -->
                  </div>
                  <div v-if="info.provincialAndMunicipalLevel==3" style="width:100%!important;margin-top: 0;"  class="layui-form-item leftBlock">
                    <div v-if="handleIndex==0">
                      <div class="over_h" >
                        服务辖区<span class="red">*</span>
                      </div>
                      <el-form>
                        <el-form-item>
                          <el-select style="margin-top:10px;" placeholder="请选择活动区域" @change="changeCity" multiple v-model="newData.authProvincesCityAreas">
                            <el-option v-for="item in cityList" :label="item.name":key="item.id" :value="item.id">{{item.name}}</el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                       <!-- <el-checkbox-group v-model="newData.authProvincesCityAreas" @change="changeCity" style="margin-top:10px;overflow:auto;">
                          <el-checkbox v-for="(item,index) in cityList" :label="item.id" :key="item.id" name="type" >{{item.name}}</el-checkbox>
                        </el-checkbox-group> -->
                    </div>
                    <div v-else style="width:100%;">
                      <div class="leftBlock cityLists">
                        <div class="over_h">
                          服务乡镇/街道<span class="red">*</span>
                        </div>

                          <el-select class="mar_t15" v-model="newData.authProvincesCityAreas" @change="changeCounty" multiple placeholder="请选择">
                            <el-option
                              v-for="item in cityList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">{{item.name}}
                            </el-option>
                          </el-select>
                      </div>
                      <div class="leftBlock cityLists">
                        <div class="over_h" >
                          服务村/社区<span class="red">*</span>
                        </div>
                        <el-select class="mar_t15" v-model="newData.authvillageAreas" @change="changeVillage" multiple placeholder="请选择">
                          <el-option
                            v-for="item in villageList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">{{item.name}}
                          </el-option>
                        </el-select>
                      </div>

                    </div>
                  </div>
                  <div v-else class="layui-form-item leftBlock">
                    <div class="over_h">
                      服务乡镇/街道<span class="red">*</span>
                    </div>
               <!--     <el-checkbox-group v-model="newData.authProvincesCityAreas" @change="changeCity" style="margin-top:10px">
                      <el-checkbox v-for="(item,index) in cityList" :label="item.id" :key="item.id" name="type" >{{item.name}}</el-checkbox>
                    </el-checkbox-group> -->
                    <el-select v-model="newData.authProvincesCityAreas" @change="changeCity" style="margin-top:10px;width:100%;" placeholder="服务乡镇/街道">
                      <el-option label="服务乡镇/街道" value=""></el-option>
                      <el-option
                         v-for="(item,index) in cityList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
                         >{{item.name}}
                       </el-option>
                    </el-select>
                  </div>
                  <!-- <div class="layui-form-item layui-inline leftBlock">
                    <div class="">请选择分类 <span class="red">*</span></div>
                    <div class="layui-input-block mar_t15 typess">
                      <div v-for="(item,index) in typess" @click="types(index)" :class="active == index ? 'cur':''">{{item}}</div>
                    </div>
                    <div class="tit">药品、疫苗请通过 <a>小牧丁APP</a> 添加</div>
                  </div> -->
                </div>

                </div>
                <div class="clear"></div>
                <div class="rkConfrim addConfrim clear cur" @click="confirmBtn">确定</div>
              </div>
           </el-form>
        </el-dialog>
        <div>共{{total}}个账号</div>
      </div>
    </div>
    <div class="botCont">
      <el-table
        class="personelTable"
        :data="userList"
        height="450"
        fixed
        style="width:1800px;text-align: center;">
        <el-table-column
         type="index"
          label="序号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="realName"
          width="150"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="userAccount"
           width="120"
          label="电话号码">
        </el-table-column>
        <el-table-column
          prop="optAuthType"
          width="180"
          label="角色类型">
          <template slot-scope="scope">
            <div v-if="scope.row.optAuthType=='0'">防疫员</div>
            <div v-if="scope.row.optAuthType=='1'">操作员</div>
            <div v-if="scope.row.optAuthType=='2'">管理员</div>
            <div v-else></div>
          </template>
        </el-table-column>

        <el-table-column
          prop="orgName"
          align="left"
          class="leftL"
          label="机构">
        </el-table-column>

        <el-table-column
          prop="provincialAndMunicipalLevelName"
          align="left"
          class="leftL"
          label="机构级别">
        </el-table-column>

        <el-table-column
          prop="authProvincesCityAreasName"
          align="left"
          class="leftL"
          :label="handleIndex==0?'辖区' :handleIndex==1?'服务的乡镇/街道':''">
        </el-table-column>

        <!-- <el-table-column
          prop="action"
          label="操作"
          width="180">
          <template slot-scope="scope" >
            <div class="actionBox">
              <div class="cursor showDetail" @click="deletes(scope.row)">删除</div>
              <div class="cursor showDetail" @click="edit(scope.row)">编辑</div>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        background
        :page-size="7"
        layout="prev, pager, next"
        @prev-click="prev"
        @next-click="next"
        @current-change="currentPage"
        :total="total" style="margin-top:50px">
      </el-pagination>
    </div>
  </div>
</template>
<!-- <script src="https://cdn.bootcss.com/hls.js/8.0.0-beta.3/hls.min.js"></script> -->
<script type="text/javascript" src="https://cdn.bootcss.com/hls.js/8.0.0-beta.3/hls.min.js"></script>
		<script type="text/javascript" src="https://cdn.bootcss.com/flv.js/1.5.0/flv.min.js"></script>
<script>
  import Vue from 'vue'
// import elCascaderMulti from "el-cascader-multi";
// Vue.use(elCascaderMulti);
 import {
   getUserList,
   delAuthUser,
   selectByPCityAreas,
   getDeptList,
   addOrUpdate,
   getUserAuthInfo,
   editOrUpdate,
   getAllBellow

 } from '@/api/system'
  export default {
    data() {
      return {
        getAllNum:'',
        options:[],
        loading:true,
        activeName: '乡镇街道',
        handleIndex:0,
        address:{
          // "code": "",
          "id": 42255
        },
        newData:{
          id:'',
          realName:'',
          phone:'',
          optAuthType:'',
          authProvincesCityAreas:[],
          authvillageAreas:[]
        },
        typess:[
           {name:'防疫员',value:'0'},
           {name:'操作员',value:'1'},
          {name:'管理员',value:'2'},
        ],
        typeList:[
          {
            typeName:'全部',
            num:'0'
          },
          {
            typeName:'管理员',
             num:'0'
          },
          {
            typeName:'操作员',
             num:'0'
          },
          {
            typeName:'防疫员',
             num:'0'
          }
        ],
        showAddDialog:false,
        form: {
          authProvincesCityAreas:'',
          realName: '',
          phone: '',
          queryCityAreas:'',
           pageNo: 1,
           pageSize: 7,
          optAuthType:null,
          deptId:''

        },
        infoQuery:{},
        nextLevelAreaIds:'',
        pageNum: 1,
        total: 0,
        totalPage:1,
        userList: [],
        active:null,
        cityList:[],
        info:'',
        addTitle:'新增人员',
        villageId:'',
        villageList:[],
        tabIndex:0,
        originList:[],
        origin:{

        }
      }
    },

    mounted() {
      this.getUserInfo()
    },
    methods: {
      tabClick(item,index,e){
        this.tabIndex = index
        if(index==0){
          this.form.optAuthType = ''
        }
        if(index==1){
          this.form.optAuthType = 2
        }
        if(index==2){
          this.form.optAuthType = 1
        }
        if(index==3){
          this.form.optAuthType = 0
        }

        this.loading = true
        this.getList()
      },

      handleClick(tab, event) {
        this.handleIndex = tab.index
        if(this.handleIndex==0){
          this.addTitle = '添加人员'
          this.form.authProvincesCityAreas = ''
        }else{
          this.addTitle = '添加防疫人员'
          this.form.authProvincesCityAreas = this.nextLevelAreaIds
        }
        this.getList()

      },
      changeType(e){
        console.log(e)
        this.form.optAuthType = e
        this.loading = true
        this.form.pageNo = 1
        this.getList()
      },
      changeOrigin(e){
          this.form.deptId = e
          this.form.pageNo = 1
           this.getList()
      },
      changeCitys(e){
        console.log(e)
        this.form.queryCityAreas = e
        this.loading = true
        this.form.pageNo = 1
        this.getList()
      },
      getUserInfo(){
        var _this = this
        getUserAuthInfo()
        .then( res => {
          if (res.data.code==0) {
              this.info = res.data.data
              this.origin.authProvincesCityAreas = this.info.authProvincesCityAreas
                this.form.authProvincesCityAreas = this.info.authProvincesCityAreas
                 this.address.id  = this.info.authProvincesCityAreas
                  this.nextLevelAreaIds = this.info.nextLevelAreaIds

              this.getList()
              this.originLs()
              // this.cityLs()
              this.getAll()
          } else {
            _this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
      },
      changeCity(e){
            console.log(e)
            this.newData.authProvincesCityAreas = e
            // this.getList()
      },
      originLs(){
        var _this = this
        getDeptList(_this.origin)
        .then( res => {
          if (res.data.code==0) {
            console.log(res)
            // res.data.data.forEach(item=>{
            //   Vue.set(item,'checked',false)
            // })
           _this.originList = res.data.data
           _this.options = res.data.data
          } else {
            _this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
      },
      // cityLs(){
      //   var _this = this
      //   selectByPCityAreas(_this.address)
      //   .then( res => {
      //     if (res.data.code==0) {
      //       console.log(res)
      //       // res.data.data.forEach(item=>{
      //       //   Vue.set(item,'checked',false)
      //       // })
      //      _this.cityList = res.data.data
      //      _this.options = res.data.data
      //     } else {
      //       _this.$message({
      //         type: 'info',
      //         message: res.data.msg
      //       })
      //     }
      //   })
      // },
      edit(item){
        console.log(item)
        this.newData.phone = item.userAccount
        this.newData.realName = item.realName
        this.active = item.optAuthType
        this.newData.id = item.id
        this.newData.authProvincesCityAreas = []
          this.newData.optAuthType = item.optAuthType.toString()
        if(item.authProvincesCityAreas.indexOf(',')==-1){
          // if()
           this.newData.authProvincesCityAreas.push(item.authProvincesCityAreas)
           console.log(this.newData.authProvincesCityAreas)
        }else{
          let array = []
         array =  item.authProvincesCityAreas.split(',')
          console.log(array)

         this.newData.authProvincesCityAreas =  this.newData.authProvincesCityAreas.concat(array)
          console.log(this.newData.authProvincesCityAreas)
         console.log(array)

        }
          this.addTitle = '编辑人员'

        this.showAddDialog = true
      },
        confirmBtn(){
          console.log(this.newData)
          if(this.newData.realName==''){
            this.$message({
              type: 'info',
              message: '请输入姓名'
            })
          }else if(this.newData.phone==''){
            this.$message({
              type: 'info',
              message: '请输入手机号'
            })
          }else if(this.newData.optAuthType==''||this.newData.optAuthType==null){
            this.$message({
              type: 'info',
              message: '请选择角色'
            })
          }else if(this.newData.authProvincesCityAreas.length<1){
            this.$message({
              type: 'info',
              message: '请选择辖区'
            })
          }else{
            console.log(this.newData)
                 this.newData.authProvincesCityAreas = this.newData.authProvincesCityAreas.join(',')

            // var _this = this
            if(this.addTitle=='新增人员'||this.addTitle=="新增防疫人员"){
              this.newData.id = null
              addOrUpdate(this.newData)
              .then( res => {
                if (res.data.code==0) {
                  console.log(res)
                  this.showAddDialog = false
                   this.loading = true
                   this.$message({
                       type: 'success',
                       message: '人员操作成功'
                     })
                  this.getList()
                 // _this.cityList = res.data.data
                } else {
                  this.$message({
                    type: 'info',
                    message: res.data.msg
                  })
                }
              })
            }else{
              editOrUpdate(this.newData)
              .then( res => {
                if(res.data.code==0){
                  this.showAddDialog = false
                   this.loading = true
                   this.$message({
                       type: 'success',
                       message: '人员操作成功'
                     })
                  this.getList()
                }else{
                   this.showAddDialog = false
                  this.$message({
                    type: 'info',
                    message: res.data.msg
                  })

                }
              })
            }

          }

        },
      closeDialog() {
        this.showAddDialog = false

      },
      types(item,index){
        this.active = index
        this.newData.optAuthType = item.value
      },
changeName(e){
  console.log(e)
  this.form.realName = e
  this.loading = true
  this.form.pageNo = 1
  this.getList()
},
changePhone(e){
  console.log(e)
  this.form.phone = e
  this.loading = true
  this.form.pageNo = 1
  this.getList()
},
      // 页码
      currentPage(e){
        this.loading = true
        this.form.pageNo = e
        console.log(this.form)
        this.getList()
      },
      prev(e){
        this.loading = true
        this.form.pageNo = e
        this.getList()
      },
      next(e){
        this.loading = true
        this.form.pageNo = e
        this.getList()
      },
      handleChange(item) {
        let cityList = this.$refs['city'].getCheckedNodes()[0].pathLabels
        this.form.cityName = cityList[1]

        this.form.provinceName = cityList[0]
        if(cityList[2]=='全部地区'){
           this.form.countyName = ''
        }else{
           this.form.countyName = cityList[2]
        }
        if(cityList[1]=='全部市区'){
          this.form.cityName = ''
        }else{
           this.form.cityName = cityList[2]
        }

      },
      onSubmit() {
        this.form.pageNo = 1
        this.getList()
      },
      reset(){
        this.form.pageNo = 1
        this.getList()
      },
      deletes(item){
        this.$confirm('是否删除本条数据?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                 var _this = this
                 delAuthUser({
                   id:item.id,
                   phone:item.userAccount,
                   realName:item.realName
                 })
                 .then( res => {
                   if(res.data.code==0){
                     _this.$message({
                       type: 'success',
                       message: '删除成功'
                     })
                     this.getList()
                   }else{
                     _this.$message({
                       type: 'info',
                       message: res.data.msg
                     })

                   }

                 })

                }).catch(() => {
                });

      },
      addPerson(){

        this.newData.realName = ''
        this.newData.phone = ''
        this.newData.optAuthType = ''
        this.active = null
        this.newData.authProvincesCityAreas = []

        this.showAddDialog = true
        if(this.handleIndex==0){
          this.addTitle  = '新增人员'
        }else{
          this.addTitle  = '新增防疫人员'
        }

        // this.newS = 0
      },
     getList(){

       var _this = this

       getUserList(_this.form)
       .then( res => {
         _this.loading = false
         if (res.data.code==0) {
           _this.total = res.data.data.pageData.total
          _this.userList = res.data.data.pageData.records

         } else {
           _this.$message({
             type: 'info',
             message: res.data.msg
           })
         }
       }).catch(res=>{
         _this.loading = false
       })
     },
     getAll(){

         var _this = this
        console.log(_this.form)
         getAllBellow(_this.form)
         .then( res => {
           // _this.loading = false
           if (res.data.code==0) {
             _this.getAllNum = res.data.data
             _this.typeList[0].num = _this.getAllNum.allTotals
             _this.typeList[1].num = _this.getAllNum.numberOfAdminUser
             _this.typeList[2].num = _this.getAllNum.numberOfOptUser
              _this.typeList[3].num = _this.getAllNum.numberOfImmunizers

           } else {
             _this.$message({
               type: 'info',
               message: res.data.msg
             })
           }
         }).catch(res=>{
           _this.loading = false
         })
       },
    },

    // 注册组件
    components: {

    },
    created() {

    },
  }
</script>

<style scoped>
  /deep/ .el-tabs__item{
    width: 110px;
    height: 60px;
    text-align: center;
    font-size: 17px;
    padding: 5px 0;
    cursor: pointer;
  }
  /deep/ .el-tabs__item.is-active{
    color: #30BF30;
    font-weight: bold;
  }
  /deep/ .el-tabs__active-bar{
    width: 110px;
  }
  /deep/ .el-tabs__nav-wrap::after{
    height:1px
  }
  .el-button--primary{
    float: right;
  }
  .el-button--primary:focus,
  .el-button--primary:hover{
    background-color: #30BF30;
    border-color: #30BF30;
  }
  /deep/ .el-button--success.is-plain{
    border-color: rgba(48, 191, 48, 1);
    color: #30BF30 !important;
    background: #fff;
  }
  /deep/ .el-button--info.is-plain{
    background: rgba(245, 245, 245, 1);
    color:#333;border-color:rgba(245, 245, 245, 1)
  }
  .layuiPdaList{
    height: calc( 100vh - 384px );
    overflow-y: auto;
  }
  @media (max-width: 1500px) {
    .layuiPdaList{
      height: calc( 100vh - 445px );
    }
  }
  .title {
    height: 60px;
    line-height: 60px;
    margin: 0;
  }

  .title h3 {
    margin: 0 !important;
  }

  .title h3 span {
    font-weight: normal;
    font-size: 16px;
    margin-left: 10px;
  }

  /deep/.el-main {
    background: #f7f7f7 !important;
  }
  /deep/ .personelTable.el-table .is-left div{
    text-align:left!important;
  }
  /deep/ .el-button{
    padding: 11px 10px;
    font-size: 15px
  }
  .pdaBoxs {
    background: #fff;
    padding: 20px 0px 10px 0px;
  }


  .btnBox{
    float: right;font-size: 16px
  }
  .btnBox button{
    font-size: 16px;height:40px;padding: 0 20px;
    line-height: 40px;
  }
  .actionBox div{
    display: inline-block;margin: 0 5px;
    color:#458CFF;
  }
  .maskBox {
     width: 100%!important;
     height: 600px!important;
   }
   .absolutes{
     height: 420px;
     overflow-y: auto;
   }
   .absolutes::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #F5F5F5;
    }

    .absolutes::-webkit-scrollbar-track{
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
      border-radius: 10px;
      background-color: #F5F5F5;
    }

   .maskBox::-webkit-scrollbar-thumb{
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.1);
      background-color: #dfdfdf;
    }
   .leftBlock {
     float: left;
     width: 45%;
     font-size: 16px;
     color: #333;
     margin-top: 10px;
     margin-bottom: 0!important;
     padding-bottom: 10px;
     margin-right: 4%;
     position: relative;
     clear: none!important;
   }
   .leftBlock:nth-child(2n-1) {
     margin-right: 4%!important;
   }
   .leftBlock .red {
     color: red;
   }
   .color99 {
     color: #999;
   }
   .mar_t15 {
     margin-top: 10px;
   }
   .layui-input-block {
     position: relative;
     margin-left: 0!important;
     min-height: 36px;
   }
   .layui-input-block.inputRadio > div{
     cursor: pointer;
     position: relative;display: inline-block;
   }
   .layui-input-block.inputRadio > div > input{
     width: 50px;position: relative;
     z-index: 99999;cursor: pointer;
   }
   .layui-input-block.inputRadio > div > input::after{
     content: '';
     position: absolute;
     left: 13px;
     top:-3px;
     width: 20px;height: 20px;
     background: url(/static/images/radius.svg) no-repeat center;
     background-size: 20px auto;
   }
   .layui-input-block.inputRadio > div > input[type="radio"]:checked::after{
     background: url(/static/images/radius_checked.png) no-repeat center;
     background-size: 20px auto
   }
   .layui-input-block.inputRadio > div > span{
     position: absolute;
     right: 0px;
   }

   .layui-input, .layui-textarea, select {
     height: 40px;
     border-radius: 5px;
   }
   .layui-input, .layui-textarea,select{
     display: block;
     width: 100%;
     text-indent: 10px;
   }
   .layui-input, .layui-textarea,select {
    border:solid 1px #e6e6e6;
    outline: none;
    background: transparent!important;
   }
   .descriptB {
     position: absolute;
     bottom: -20px;
     left: 0;
     color: #999999;
     font-size: 16px;
   }
   .ds_I {
     display: inline-block;
   }
   .baozhuang>input{
     height: 36px;
     width: 100px!important;
     float: left;
     text-indent: 10px;
     margin-right: 15px;
     border:solid 1px #e6e6e6
   }
   .baozhuang>select{
     height: 40px;
     width: 100px!important;
     float: left;
     margin-right: 15px;
   }
   .baozhuang>select:last-child{
     margin-right: 0;
   }
   .baozhuang span{
     float: left;margin-right: 15px;
     margin-top: 10px;
   }
   .rkConfrim.cur {
     cursor: pointer;
     background: #30BF30;
     color: #fff;
   }
   .addConfrim {
     margin-top: 70px!important;
   }
   .rkConfrim {
     color: #999999;
     background: #F5F7FA;
     border-radius: 5px;
     width: 100px;
     height: 40px;
     line-height: 40px;
     margin: 0px auto 0;
     text-align: center;
     position: relative;
   }
   .rkInputBlock {
     overflow: hidden;
     margin: 60px 60px;
   }
   .rkInputBlock>div {
     float: left;
     position: relative;
     line-height: 40px;
   }
   .rkInputBlock2 img{
     width: 80px;display: block;
     margin: 0 auto 20px;
   }
   .rkInputBlock.rkInputBlock2 > div{
     font-size: 16px;color:#333;
     text-align: center;
   }
   .rkInputBlock.rkInputBlock2>div{
     float: none;
   }
   .mar_r20 {
     margin-right: 20px;
   }
   .rkInput {
     width: 100%;
     border: 1px solid #D9D9D9;
     border-radius: 5px;
     margin-bottom: 15px;
     position: relative;
   }
   .rkInput input {
     border: none!important;
     text-indent: 20px;
     width: 80%;
     height: 35px;
     outline: none;
   }
   .danWei {
     position: absolute;
     top: 0;
     right: 15px;
     color: #999999;
   }
   .bgF5 {
     background: #F5F7FA!important;
   }
   .rknumss div {
     height: 40px;
     line-height: 40px;
     margin-bottom: 20px;
     cursor: pointer;
   }
   .rknumss label {
     display: inline-block;
     width: 20px;
     height: 20px;
     border-radius: 50%;
     background: url(/static/images/radius.svg) no-repeat center;
     background-size: 20px 20px;
     float: left;
     cursor: pointer;
     margin-right: 10px;
     margin-top: 10px;
   }
   .rknumss div.checked label {
     background: url(/static/images/radius_checked.png) no-repeat center;
     background-size: 20px 20px;
   }
   .rknumss span {
     font-size: 15px;
     color: #333;
     float: left;
   }
   .rknumss input {
     width: 60%;
     height: 40px;
     line-height: 40px;
     background-color: rgba(255, 255, 255, 0);
     border: solid 1px rgba(217, 217, 217, 1);
     border-radius: 5px;
     text-align: center;
     font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
     font-size: 18px;
     float: right;
     outline: none;
     padding: 0;
   }
   .rknumss input:disabled {
     background-color: rgba(245, 247, 250, 1);
   }
   .hide{
     display: none;
   }
   .delBtnBox {
     text-align: center;
   }
  .delBtnBox div{
    display: inline-block;margin: 0 10px;
    cursor: pointer;
  }
  .tit{
    font-size: 16px;color:#999;
  }
  .tit a{
    color:#30BF30
  }
  .red{
    color:red;
  }
  .typess div{
    cursor: pointer;
    display: inline-block;
    padding: 0px 15px;
    border: 1px solid #F5F7FA;
    background: #F5F7FA;
    color: #333;
    border-radius: 5px;
    margin-right: 20px;
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .typess div.cur{
    background-color: #fff;
    border: 1px solid #30bf30;
    color: #30bf30;
  }
  /deep/ .el-checkbox{
    width:100px!important;
    margin:5px 0;
  }
  /deep/ .el-message-box{
    width:300px!important;
  }
  /deep/ .cityLists.leftBlock .el-select{
    width: 100%;
  }
  /deep/ .cityLists.leftBlock .el-select .el-tag.el-tag--info{
    font-size: 15px;
  }
  .typeList{
    margin-bottom: 22px;
  }
  .typeList div {
    cursor: pointer;
    float: left;
    padding: 0px 20px;
    border: 1px solid #F5F7FA;
    background: #F5F7FA;
    color: #333;
    border-radius: 5px;
    margin-right: 20px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
  }
  .typeList div.cur {
    background-color: #fff;
    border: 1px solid #30bf30;
    color: #30bf30;
  }
  .typeList div b{
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/personnel.vue